import { computed, Injectable, signal } from '@angular/core';
import { type NotificationType } from '../enums/notificationtype.enum';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private readonly getMessages = signal<any[]>([]);
  private readonly message = signal({});

  private readonly currentMessages = computed(() => {
    return this.getMessages();
  });

  readonly messagesSignal = this.currentMessages;

  addNotification(newMessage: string, messageType: NotificationType, pageName: string, ctaData?: any): void {
    this.message.set({ message: newMessage, messageType, pageName, ctaData });
    this.updateNotificaitons(this.message());
  }

  private updateNotificaitons(messageObject: any): void {
    this.getMessages.update((messages) => {
      const dupeMessage = messages.find((msg) => {
        return (
          msg.message.toLowerCase() === messageObject.message.toLowerCase() &&
          msg.messageType === messageObject.messageType &&
          msg.pageName === messageObject.pageName
        );
      });
      if (dupeMessage) {
        return messages;
      } else {
        const newArr = [...messages, messageObject];
        return newArr;
      }
    });
  }

  deleteNotification(message: string): void {
    this.getMessages.update((messages) => messages.filter((notification) => notification.message !== message));
  }

  // TODO: rename to clearNotifications
  clearAllNotifications(pageName = ''): void {
    if (pageName) {
      this.getMessages.update((messages) => messages.filter((notification) => notification.pageName !== pageName));
    } else {
      this.getMessages.set([]);
    }
  }
}
